define('components/spinner/model', [], function () {
    function Model(jsonModel) {
        jsonModel = jsonModel || {};

        this.active = ko.observable(jsonModel.active).unwrap().default(true);        
        this.height = ko.observable(jsonModel.height).unwrap().default(0);        

        this.options = ko.pureComputed(this._buildOptions.bind(this, jsonModel));
    }

    Model.prototype._buildOptions = function (jsonModel) {
        return _.chain(jsonModel)
            .omit('active', 'inline', 'height')
            .mapObject(function (value) { return ko.unwrap(value) })
            .value();
    };

    return Model;
});